import dates from '@/helpers/dates';

// Normalize a single service level entry: keep existing camelCase keys, but
// backfill them from snake_case responses when pagination endpoints are used.
const serviceLevelPostProcessor = (data) => {
  if (!data) {
    return {};
  }

  const createdAt = data.createdAt ?? data.created_at;
  const updatedAt = data.updatedAt ?? data.updated_at;
  const archivedAt = data.archivedAt ?? data.archived_at;

  return {
    ...data,
    ...(createdAt && { createdAt }),
    ...(updatedAt && { updatedAt }),
    ...(archivedAt && { archivedAt }),
    parsedCreatedAt: createdAt ? dates.parseDate(createdAt) : '',
    parsedUpdatedAt: updatedAt ? dates.parseDate(updatedAt) : '',
  };
};

const serviceLevelsPostProcessor = (data) => {
  if (!data) {
    return { items: [], total: 0 };
  }

  // Support multiple API response formats
  const items =
    data.items || // New paginated format
    data.service_levels || // API format with underscore
    data.serviceLevels || // Old format
    [];

  const parsedItems = items.map((item) => serviceLevelPostProcessor(item));

  const result = {
    items: parsedItems,
    total: data.total || data.total_size || parsedItems.length,
  };

  return result;
};

export default serviceLevelsPostProcessor;
